// extracted by mini-css-extract-plugin
export default {"imageBox":"Feature_imageBox__yh9ft","feature":"Feature_feature__ryeiI","title":"Feature_title__tspfj","paragraph":"Feature_paragraph__5D3Zr"};